<div class="modal-header">
    <h4 class="modal-title">{{'Modals.lostSessionTitle' | translate}}</h4>
</div>
<div class="session-expired-body">
    <p>{{'Modals.lostSessionBody' | translate}}</p>
</div>
<div class="session-expired-footer">
    <button (click)="buttonClick()" class="btn btn-primary form-control">{{'Modals.lostSessionButton' | translate}}</button>
</div>
